import { TeamWithRels } from '@statsbomb/parachute-types';
import { atomWithSuspenseQuery } from 'jotai-tanstack-query';
import { comparisonIdAtom } from '@/atoms/queryParams';
import { fetchClientAtom } from '../client';

// all the teams a comparison player has played for
export const rawPlayerComparisonTeamsAtom = atomWithSuspenseQuery(get => {
  const { fetch } = get(fetchClientAtom);
  const comparisonId = get(comparisonIdAtom);
  const queryKey = ['playerComparisonTeams', comparisonId] as const;

  const queryFn = async ({ queryKey: [, id] }: { queryKey: typeof queryKey }) => {
    if (!id) return [];
    return (await fetch(`/player/${id}/teams`)) as TeamWithRels[];
  };

  return { queryKey, queryFn };
});
